import React from 'react';

const SeIndexSnapshotFormModal = React.lazy(() => import('../components/FormModal'));
const seIndexSnapshotModalRegistry = {
    company_seIndexSnapshotId: SeIndexSnapshotFormModal
};
export default seIndexSnapshotModalRegistry;
